(function(window)
{
	"use strict";

	//The window does not include any createjs libraries
	if(!window.createjs) return;

	var Ticker = createjs.Ticker;
	if(Ticker)
	{
		Ticker.setPaused = function(value)
		{
			Ticker.paused = value;
		};

		Ticker.getPaused = function()
		{
			return Ticker.paused;
		};
	}

	var Sound = createjs.Sound;
	if(Sound)
	{
		Sound.setPaused = function(paused)
		{
			var instances = this._instances;
			for (var i = instances.length; i--; ) {
				instances[i].paused = paused;  // NOTE stop removes instance from this._instances
			}
		};
	}

}(window));